import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="pt-28 pb-16 md:pt-36 md:pb-24 px-4 bg-cream overflow-hidden" data-id="element-84">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-85">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center space-y-6" data-id="element-86">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-sage text-primary font-semibold text-sm mb-2" data-id="element-87">
            <StarIcon className="w-4 h-4 mr-1 fill-accent text-accent" data-id="element-88" />
            <span data-id="element-89">El método #1 en nutrición canina</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl text-charcoal leading-[1.15] mb-4 max-w-2xl font-serif font-[700]" data-id="element-90">
            Mejorá la salud de tu perro en 7 días
          </h1>

          <p className="text-2xl md:text-3xl text-primary italic font-serif leading-relaxed mb-6 max-w-xl tracking-wide font-[600]" data-id="element-91">
            Con alimentación natural, sin errores ni complicaciones
          </p>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-lg" data-id="element-92">
            Con <strong className="text-primary" data-id="element-93">Nutrición Canina Fácil</strong>{' '}
            vas a poder alimentar a tu perro de forma natural y segura, incluso
            si hoy no sabés por dónde empezar.
          </p>

          <div className="pt-4 flex flex-col sm:flex-row items-center gap-4" data-id="element-94">
            <CTAButton data-id="element-95" />
          </div>

          {/* Trust Badges */}
          <div className="pt-6 border-t border-gray-200 mt-6 w-full max-w-lg" data-id="element-96">
            <div className="flex items-center justify-center mb-3" data-id="element-97">
              <div className="flex mr-2" data-id="element-98">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-accent text-accent" data-id="element-99" />)}
              </div>
              <span className="font-semibold text-charcoal" data-id="element-100">
                +2.000 dueños satisfechos
              </span>
            </div>
            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-600 font-medium" data-id="element-101">
              <span className="flex items-center" data-id="element-102">
                <ZapIcon className="w-4 h-4 mr-1 text-accent" data-id="element-103" /> Acceso
                inmediato
              </span>
              <span className="flex items-center" data-id="element-104">
                <ShieldCheckIcon className="w-4 h-4 mr-1 text-primary" data-id="element-105" />{' '}
                Garantía 7 días
              </span>
              <span className="flex items-center" data-id="element-106">
                <LockIcon className="w-4 h-4 mr-1 text-gray-500" data-id="element-107" /> Pago seguro
              </span>
            </div>
          </div>
        </motion.div>

        {/* Mockup */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative flex justify-center items-center perspective-1000" data-id="element-108">
          {/* Decorative background blob */}
          <div className="absolute inset-0 bg-sage rounded-full blur-3xl opacity-50 transform scale-110" data-id="element-109"></div>

          {/* Ebook Mockup */}
          <motion.div whileHover={{
          scale: 1.02
        }} className="relative z-10 w-full max-w-md flex items-center justify-center transform transition-transform duration-500" style={{
          filter: 'drop-shadow(0 25px 40px rgba(0,0,0,0.2)) drop-shadow(0 10px 15px rgba(0,0,0,0.12))'
        }} data-id="element-110">
            <img src="https://cdn.magicpatterns.com/uploads/juvrdCDTRt1qFbZEHp6o8m/Imagen_ebook_portada_primera.webp" alt="Nutrición Canina Fácil - Ebook + 7 Bonos de Regalo" className="w-full h-auto object-contain" loading="eager" decoding="sync" fetchPriority="high" width={800} height={800} data-id="element-111" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}